// extracted by mini-css-extract-plugin
module.exports = {"base":"passwordRequirements_base__6qipK","reqsColumn":"passwordRequirements_reqsColumn__b4GBD"};